import { ContainerProps } from 'styled-bootstrap-grid';

export const container: ContainerProps = {
  fluid: true,
};
